const QualifiedEntityParametersDefaults = {
  expectedMutation: "anyMutation"
};
export {
  QualifiedEntityParametersDefaults
};
//# sourceMappingURL=QualifiedEntityParameters.js.map
